import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const ProgramQrGenrateSlice = createSlice({
  name: 'ProgramQrGenrate',
  initialState,
  reducers: {
    Program_Qr_Genrate_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    Program_Qr_Genrate_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    Program_Qr_Genrate_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_Program_Qr_Genrate_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {  Clear_Program_Qr_Genrate_Check, Program_Qr_Genrate_failure,  Program_Qr_Genrate_success, Program_Qr_Genrate_request } = ProgramQrGenrateSlice.actions

export default ProgramQrGenrateSlice.reducer